import { gatewayClient, createService } from './connectors/httpClient';
import { readCookie } from 'packages/helpers/cookie';
import { createQuery as createQueryGeneric } from 'packages/helpers/queryString';

export function createQuery(params) {
    const { type, customerId, ownershipSource, subType, includeEmptyCollection } = params;
    const safeCustomerId = customerId || readCookie('currentCompany');

    return `type=${type}\
${subType ? `&subType=${subType}` : ''}\
${typeof includeEmptyCollection === 'boolean' ? `&includeEmptyCollection=${includeEmptyCollection}` : ''}\
&customerId=${safeCustomerId}\
&ownershipSource=${ownershipSource}\
&${createQueryGeneric(params)}`;
}

const httpClient = gatewayClient('/collections');

const collectionsService = createService(httpClient, (client) => ({
    getCollections(query: string, includeCollectionId = false) {
        return client.get<{ items: unknown[]; totalItems: number; page: number }>(
            `?${query}${includeCollectionId ? '&includeCollectionId=' + includeCollectionId : ''}`,
        );
    },

    getCollection(id) {
        return client.get(`/${id}`).then(({ status, json }) => ({ status, collection: json }));
    },

    async addToCollection({
        collectionId,
        customerId,
        ids,
        name,
        type,
        subType,
    }: {
        collectionId?: number;
        customerId: number;
        ids?: number[];
        name: string;
        type: string;
        subType?: string;
    }) {
        let id = collectionId;

        if (!id) {
            const requestData = !subType ? { customerId, name, type } : { customerId, name, type, subType };
            const response = await client.put<{ id: number }>('', requestData);

            if (response.status !== 200 || !ids || !ids.length) {
                return response;
            }

            id = response.json.id;
        }

        const requestData = !subType ? { ids, type } : { ids, type, subType };

        return client.put(`/${id}/items`, requestData);
    },

    removeFromCollection(collectionId, ids, type) {
        return client.delete(`/${collectionId}/items`, { ids, type });
    },

    deleteCollections(ids) {
        return client.delete('', { ids });
    },

    renameCollection(id, name) {
        return client.put(`/${id}`, { name });
    },

    moveToCollection(collectionId, ids, type) {
        return client.put(`/${collectionId}/items`, { ids, type });
    },

    addTemplatesToCategories(templateIds: number[], categoryIds: number[]) {
        return client.put('/template-categories/items', { templateIds, categoryIds });
    },

    addCover(customerId, collectionId, item) {
        return client
            .post<{ signedUrl: string; originalPath: string; assetId: string }>(`/${collectionId}/store-path`, item)
            .then(({ status, json }) => ({ status, data: json }));
    },

    editCollection(id, collectionUpdates) {
        return client.put(`/${id}`, collectionUpdates);
    },
}));

export default collectionsService;
